import styles from './Header.module.css';

interface MenuOption {
    label: string;
    url: string;
    newTab?: boolean;
}

interface HeaderProps {
    logoUrl: string;
    title: string;
    options: MenuOption[];
}

export function Header({ logoUrl, title, options }: HeaderProps) {

    const handleNavigation = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const url = event.target.value;
        if (!url) return;

        const option = options.find(o => o.url === url);
        const openInNewTab = option?.newTab || url.startsWith('http');

        if (openInNewTab) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.click();
            event.target.value = '';
        } else {
            window.location.href = url;
        }
    };

    return (
        <header className={styles.header}>
            <div className={styles.logoContainer}>
                <img src={logoUrl} alt="Logo" className={styles.logo} />
            </div>

            <div className={styles.titleContainer}>
                <h1 className={styles.title}>{title}</h1>
            </div>

            <div className={styles.menuContainer}>
                <select
                    className={styles.select}
                    onChange={handleNavigation}
                    defaultValue=""
                >
                    <option value="" disabled hidden>MAIS ACESSOS</option>

                    {options.map((option, index) => (
                        <option
                            key={index}
                            value={option.url}
                            className={styles.optionItem}
                        >
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </header>
    );
}